import './HamburgerMenuItem.css';
import { useState } from "react";

export default function HamburgerMenuItem({ item }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="hamburger-menu-item">
            <div className="hamburger-menu-item-main">
                <div className="hamburger-menu-item-icon">
                    <img
                        src={item.image.replace('.png','-black.png')}
                        alt={`${item.name} icon`}
                        className="hamburger-menu-item-icon"
                    />
                </div>

                <a className="hamburger-menu-item-name" href={item.link}>{item.name}</a>

                {item.sub.length > 0 && (
                    <button
                        type="button"
                        className="hamburger-menu-arrow"
                        onClick={() => setOpen(v => !v)}
                    >
                        <img
                            src="/images/arrow-icon.webp"
                            alt=""
                            className={`hamburger-menu-arrow-icon${open ? '--active' : ''}`}
                        />
                    </button>
                )}
            </div>

            <div className={`hamburger-menu-content ${open ? 'open' : ''}`}>
                {item.sub.map((sub, i) => (
                    <a className="hamburger-content-item" key={i} href={sub.link}>
                        {sub.name}
                    </a>
                ))}
            </div>
        </div>
    );
}
